<div class="font-bold mb-3" i18n>eSIM contains network credentials used to authenticate your network.</div>
<div class="font-bold mb-3" i18n>Please select the authentication algorithm.</div>
<div class="ml-6">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.authenticationAlgorithm"
          inputId="networkAuthentication.authenticationAlgorithm#1"
          value="1"
          [(ngModel)]="profileValues.networkAuthentication.authenticationAlgorithm"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 label-clickable" for="networkAuthentication.authenticationAlgorithm#1" i18n>Milenage</label>
      </td>
    </tr>
    <tr>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.authenticationAlgorithm"
          inputId="networkAuthentication.authenticationAlgorithm#2"
          value="2"
          [(ngModel)]="profileValues.networkAuthentication.authenticationAlgorithm"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 label-clickable" for="networkAuthentication.authenticationAlgorithm#2" i18n>TUAK</label>
      </td>
    </tr>
    <tr style="display: none">
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.authenticationAlgorithm"
          inputId="networkAuthentication.authenticationAlgorithm#3"
          value="3"
          [disabled]="true"
          [(ngModel)]="profileValues.networkAuthentication.authenticationAlgorithm"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 label-clickable" for="networkAuthentication.authenticationAlgorithm#3" i18n>USIM Test Algorithm (aka XOR)</label>
      </td>
    </tr>
  </table>
</div>
